
import { Component, Vue, Prop } from "vue-property-decorator";
import deviceItem from "@/views/scanforacceptpacketgeton/deviceItem";

@Component({
  name: "deviceStatus",
})
export default class extends Vue {
  @Prop() readonly deviceItems: deviceItem[];
  public checkactionerror(item): boolean {
    if (item.status == "true") {
      return false;
    } else if (item.status == "false") {
      return true;
    } else if (item.status == "defult") {
      return false;
    }
  }
  public checkactionsuccess(item): boolean {
    if (item.status == "true") {
      return true;
    } else if (item.status == "false") {
      return false;
    } else if (item.status == "defult") {
      return false;
    }
  }
  public checkactiondefult(item): boolean {
    if (item.status == "true") {
      return false;
    } else if (item.status == "false") {
      return false;
    } else if (item.status == "defult") {
      return true;
    }
  }
  // private deviceItems: deviceItem[] = []
}
